<template>
  <div class="w-full">
    <div>
      {{ $route.meta.title }}
    </div>
    <div class="flex justify-end">
      <v-btn @click="onPressAdd" small>Add</v-btn>
    </div>
    <div>
      <v-data-table
        :headers="headers"
        :items="departments"
        :loading="loading"
        :search="search"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn text @click="edit(item)">
            <v-icon @click="item"> mdi-pencil </v-icon>
            Edit
          </v-btn>

          <v-btn text @click="del(item)">
            <v-icon @click="item"> mdi-delete </v-icon>
            Delete
          </v-btn>
        </template>
      </v-data-table>
    </div>
    <v-dialog
      v-model="addDialog"
      scrollable
      persistent
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <AddComponent @cancelAdd="cancelAdd" />
    </v-dialog>

    <v-dialog
      v-model="editDialog"
      scrollable
      persistent
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <EditComponent :item="item" @cancelEdit="cancelEdit" />
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      scrollable
      persistent
      :overlay="false"
      max-width="300px"
      transition="dialog-transition"
    >
      <DeleteComponent :item="item" @cancelDelete="cancelDelete" />
    </v-dialog>
  </div>
</template>
<script>
// import AddComponent from "@/pages/departments/Add";
import AddComponent from "../../settingsScreen/DepartmentSettingsScreen/components/Add";
import Axios from "axios";
import EditComponent from "../../settingsScreen/DepartmentSettingsScreen/components/Edit";
import DeleteComponent from "../../settingsScreen/DepartmentSettingsScreen/components/Delete";
import EventBus from "@/EventBus";

export default {
  data() {
    return {
      loading:false,
      search:null,
      item: {},
      editDialog: false,
      deleteDialog: false,
      departments: [],
      addDialog: false,
      headers: [
        {
          text: "Department",
          value: "department",
        },
        {
          text: "Actions",
          value: "actions",
        },
      ],
    };
  },
  beforeDestroy() {
    EventBus.$off("refreshDepartment");
  },
  components: { AddComponent, EditComponent, DeleteComponent },
  mounted() {
    this.getDepartments();
    EventBus.$on("refreshDepartment", () => {
      this.getDepartments();
      this.editDialog = false;
      this.deleteDialog = false;
      this.addDialog = false;
    });
  },
  methods: {
    onPressAdd() {
      this.addDialog = true;
    },
    cancelAdd() {
      this.addDialog = false;
    },
    cancelDelete() {
      this.deleteDialog = false;
    },
    edit(item) {
      this.item = item;
      this.editDialog = true;
    },
    cancelEdit() {
      this.editDialog = false;
    },
    del(item) {
      this.item = item;
      this.deleteDialog = true;
    },
    getDepartments() {
      Axios.get("/departments").then((res) => {
        this.departments = res.data;
      });
    },
  },
};
</script>

